/**
 * @flow
 * @relayHash bc7af0a4c67ccda7517ec3403f428759
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CompletedPaymentsContainer_viewer$ref = any;
export type CompletedPaymentsQuery_CompletedPayments_QueryVariables = {|
  completed_payments_before?: ?any,
  completed_payments_after?: ?any,
  count: number,
  cursor?: ?string,
|};
export type CompletedPaymentsQuery_CompletedPayments_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: CompletedPaymentsContainer_viewer$ref
  |}
|};
export type CompletedPaymentsQuery_CompletedPayments_Query = {|
  variables: CompletedPaymentsQuery_CompletedPayments_QueryVariables,
  response: CompletedPaymentsQuery_CompletedPayments_QueryResponse,
|};
*/


/*
query CompletedPaymentsQuery_CompletedPayments_Query(
  $completed_payments_before: ISO8601Type
  $completed_payments_after: ISO8601Type
  $count: Int!
  $cursor: String
) {
  viewer {
    ...CompletedPaymentsContainer_viewer_11BmFI
    id
  }
}

fragment CompletedPaymentsContainer_viewer_11BmFI on User {
  s_time_zone
  completed_payments(before_time: $completed_payments_before, after_time: $completed_payments_after, first: $count, after: $cursor) {
    edges {
      node {
        ... on CashPayment {
          id
          amount_cents
          amount_currency
          name
          paid_at
          invoice {
            id
            title
            workspaces {
              edges {
                node {
                  event {
                    title
                    id
                  }
                  id
                }
              }
            }
          }
        }
        ... on CheckPayment {
          id
          amount_cents
          amount_currency
          name
          paid_at
          invoice {
            id
            title
            workspaces {
              edges {
                node {
                  event {
                    title
                    id
                  }
                  id
                }
              }
            }
          }
        }
        ... on CustomPayment {
          id
          amount_cents
          amount_currency
          name
          paid_at
          label
          invoice {
            id
            title
            workspaces {
              edges {
                node {
                  event {
                    title
                    id
                  }
                  id
                }
              }
            }
          }
        }
        ... on SquarePayment {
          id
          amount_cents
          amount_currency
          name
          paid_at
          invoice {
            id
            title
            workspaces {
              edges {
                node {
                  event {
                    title
                    id
                  }
                  id
                }
              }
            }
          }
        }
        ... on Node {
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "completed_payments_before",
    "type": "ISO8601Type",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "completed_payments_after",
    "type": "ISO8601Type",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "after_time",
    "variableName": "completed_payments_after",
    "type": "ISO8601Type"
  },
  {
    "kind": "Variable",
    "name": "before_time",
    "variableName": "completed_payments_before",
    "type": "ISO8601Type"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count",
    "type": "Int"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount_cents",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount_currency",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "paid_at",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "invoice",
  "storageKey": null,
  "args": null,
  "concreteType": "Invoice",
  "plural": false,
  "selections": [
    v2,
    v7,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "workspaces",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "WorkspaceEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Workspace",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [
                    v7,
                    v2
                  ]
                },
                v2
              ]
            }
          ]
        }
      ]
    }
  ]
},
v9 = [
  v3,
  v4,
  v5,
  v6,
  v8
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "CompletedPaymentsQuery_CompletedPayments_Query",
  "id": null,
  "text": "query CompletedPaymentsQuery_CompletedPayments_Query(\n  $completed_payments_before: ISO8601Type\n  $completed_payments_after: ISO8601Type\n  $count: Int!\n  $cursor: String\n) {\n  viewer {\n    ...CompletedPaymentsContainer_viewer_11BmFI\n    id\n  }\n}\n\nfragment CompletedPaymentsContainer_viewer_11BmFI on User {\n  s_time_zone\n  completed_payments(before_time: $completed_payments_before, after_time: $completed_payments_after, first: $count, after: $cursor) {\n    edges {\n      node {\n        ... on CashPayment {\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          invoice {\n            id\n            title\n            workspaces {\n              edges {\n                node {\n                  event {\n                    title\n                    id\n                  }\n                  id\n                }\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          invoice {\n            id\n            title\n            workspaces {\n              edges {\n                node {\n                  event {\n                    title\n                    id\n                  }\n                  id\n                }\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          label\n          invoice {\n            id\n            title\n            workspaces {\n              edges {\n                node {\n                  event {\n                    title\n                    id\n                  }\n                  id\n                }\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          invoice {\n            id\n            title\n            workspaces {\n              edges {\n                node {\n                  event {\n                    title\n                    id\n                  }\n                  id\n                }\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CompletedPaymentsQuery_CompletedPayments_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CompletedPaymentsContainer_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "completed_payments_after",
                "variableName": "completed_payments_after",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "completed_payments_before",
                "variableName": "completed_payments_before",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CompletedPaymentsQuery_CompletedPayments_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_time_zone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "completed_payments",
            "storageKey": null,
            "args": v1,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PaymentEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      v2,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "SquarePayment",
                        "selections": v9
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "CustomPayment",
                        "selections": [
                          v3,
                          v4,
                          v5,
                          v6,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "label",
                            "args": null,
                            "storageKey": null
                          },
                          v8
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "CheckPayment",
                        "selections": v9
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "CashPayment",
                        "selections": v9
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "completed_payments",
            "args": v1,
            "handle": "connection",
            "key": "CompletedPayments_completed_payments",
            "filters": [
              "before_time",
              "after_time"
            ]
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '136ca6ae341d65b58d8d0131a1dfb2fc';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/routes/__generated__/CompletedPaymentsQuery_CompletedPayments_Query.graphql.js